export enum ROLES {
  NONE = '',
  ADMINISTRATOR = 'administrator',
  TEACHER = 'instructor',
  STUDENT = 'learner',
  LTICONFIG = 'lticonfig'
}

export function isAdmin(role: ROLES) {
  return !!role && role === ROLES.ADMINISTRATOR;
}

export function isTeacher(role: ROLES): boolean {
  return !!role && (role === ROLES.TEACHER || isAdmin(role));
}

export function isStudent(role: ROLES): boolean {
  return !!role && (role === ROLES.STUDENT)
}
